import React from "react";

//components
import { Grid, Slider } from "@mui/material";
import { Knob } from "components/shared/ReactRotaryKnob";
import UpDownButton from "components/shared/UpDownButton";

//assets
import filterResetButton_in from "assets/phase4/ResetEffects_in.png";
import filterResetButton_out from "assets/phase4/ResetEffects_out.png";
import sliderBaseBackground from "assets/phase3/sliderBack.png";
import sliderSlide from "assets/phase3/sliderThumb.png";
//IR effects
import marbelHallIR from "assets/effects/Marbel.mp4";
import smokingRoomIR from "assets/effects/Smoke.mp4";
//knob skins
import pannerKnob from "assets/knobSkins/phase2panner";
import filterKnob from "assets/knobSkins/phase2filter";
//helpers
import getNamesAsset from "loaders/layerNames";

const styles = {
  knobGrid: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
  },
  muteControlButton: {
    width: "90%",
    height: "85%",
    position: "relative",
  },
  panner: {
    width: "100%",
    height: "21.43%",
  },
  slider: {
    width: "100%",
    height: "64.29%",
    justifyContent: "center",
  },
  sliderBase: {
    width: "85%",
    backgroundImage: `url(${sliderBaseBackground})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    paddingBottom: "4%",
    paddingTop: "10%",
  },
  sliderSlide: {
    width: "60%",
    left: "10%",
    position: "relative",
    backgroundImage: `url(${sliderSlide})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  fullContainer: {
    height: "100%",
    width: "100%",
  },
  filterResetBtn: {
    width: "90%",
    height: "80%",
    position: "relative",
    left: "5%",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
};

class UniversalControler extends React.Component {
  timestamps = [];

  constructor(props) {
    super(props);
    this.state = {
      volume: props.initialVolume,
      panning: props.initialPanning,
      muted: props.initialMuted,
      solo: props.initialSolo,
      eq1Connected: false,
      eq2Connected: false,
      reverb1Connected: false,
      reverb2Connected: false,
      reverb1Value: 0,
      reverb2Value: 0,
      eqFilter1Value: 0,
      eqFilter2Value: 0,
      selectedState: props.selected,
    };
    this.eq1ButtonRef = React.createRef();
    this.eq2ButtonRef = React.createRef();
    this.eq3ButtonRef = React.createRef();
    this.eq4ButtonRef = React.createRef();
    this.eq5ButtonRef = React.createRef();
    this.phoneButtonRef = React.createRef();
    this.announcCurrenttime = props.announcCurrenttime;
    this.audioContext = props.audioContextInstance;
    this.biquadFilter1 = this.audioContext.createBiquadFilter();
    this.biquadFilter2 = this.audioContext.createBiquadFilter();

    this.biquadFilter3 = this.audioContext.createBiquadFilter();
    this.biquadFilter4 = this.audioContext.createBiquadFilter();

    this.eq1GainNode = this.audioContext.createGain();
    this.eq2GainNode = this.audioContext.createGain();

    this.reverb1ConvFilter = this.audioContext.createConvolver();
    this.reverb2ConvFilter = this.audioContext.createConvolver();
    this.reverb1LowpassFilter = this.audioContext.createBiquadFilter();
    this.reverb1HighpassFilter = this.audioContext.createBiquadFilter();
    this.reverb2LowpassFilter = this.audioContext.createBiquadFilter();
    this.reverb2HighpassFilter = this.audioContext.createBiquadFilter();
    this.reverb1DryGainNode = this.audioContext.createGain();
    this.reverb1WetGainNode = this.audioContext.createGain();
    this.reverb2DryGainNode = this.audioContext.createGain();
    this.reverb2WetGainNode = this.audioContext.createGain();

    this.masterGain = this.audioContext.createGain();

    this.pannerNodeInstance = this.audioContext.createStereoPanner();

    this.biquadFilter1.type = "lowpass";
    this.biquadFilter1.frequency.value = 3475;
    this.biquadFilter1.Q.value = 0.698;

    this.biquadFilter2.type = "highpass";
    this.biquadFilter2.frequency.value = 500;
    this.biquadFilter2.Q.value = 0.668;

    this.biquadFilter3.type = "lowpass";
    this.biquadFilter3.frequency.value = 991;
    this.biquadFilter3.Q.value = 1;

    this.biquadFilter4.type = "highshelf";
    this.biquadFilter4.frequency.value = 465;
    this.biquadFilter4.gain.value = 10;
    this.biquadFilter4.Q.value = 8.775;

    this.reverb1LowpassFilter.type = "lowpass";
    this.reverb1LowpassFilter.frequency.value = 13000;
    this.reverb1LowpassFilter.Q.value = 1;

    this.reverb1HighpassFilter.type = "highpass";
    this.reverb1HighpassFilter.frequency.value = 300;
    this.reverb1HighpassFilter.Q.value = 1;

    this.reverb2LowpassFilter.type = "lowpass";
    this.reverb2LowpassFilter.frequency.value = 13000;
    this.reverb2LowpassFilter.Q.value = 1;

    this.reverb2HighpassFilter.type = "highpass";
    this.reverb2HighpassFilter.frequency.value = 300;
    this.reverb2HighpassFilter.Q.value = 1;

    fetch(marbelHallIR).then((res) => {
      res.arrayBuffer().then((arrayBuffer) => {
        this.audioContext
          .decodeAudioData(arrayBuffer)
          .then(
            (decodedBuffer) => (this.reverb1ConvFilter.buffer = decodedBuffer)
          );
      });
    });

    fetch(smokingRoomIR).then((res) => {
      res.arrayBuffer().then((arrayBuffer) => {
        this.audioContext
          .decodeAudioData(arrayBuffer)
          .then(
            (decodedBuffer) => (this.reverb2ConvFilter.buffer = decodedBuffer)
          );
      });
    });
  }

  eq1Connect() {
    this.audioTrack.connect(this.biquadFilter1);
    this.biquadFilter1.connect(this.biquadFilter2);
    this.biquadFilter2.connect(this.eq1GainNode);
    this.eq1GainNode.connect(this.masterGain);
    this.setState({ eq1Connected: true });
  }
  eq1Disconnect() {
    this.audioTrack.disconnect(this.biquadFilter1);
    this.biquadFilter1.disconnect(this.biquadFilter2);
    this.biquadFilter2.disconnect(this.eq1GainNode);
    this.eq1GainNode.disconnect(this.masterGain);
    this.setState({ eq1Connected: false });
  }

  eq2Connect() {
    this.audioTrack.connect(this.biquadFilter3);
    this.biquadFilter3.connect(this.biquadFilter4);
    this.biquadFilter4.connect(this.eq2GainNode);
    this.eq2GainNode.connect(this.masterGain);
    this.setState({ eq2Connected: true });
  }
  eq2Disconnect() {
    this.audioTrack.disconnect(this.biquadFilter3);
    this.biquadFilter3.disconnect(this.biquadFilter4);
    this.biquadFilter4.disconnect(this.eq2GainNode);
    this.eq2GainNode.disconnect(this.masterGain);
    this.setState({ eq2Connected: false });
  }

  reverb1Connect() {
    this.audioTrack.connect(this.reverb1DryGainNode);
    this.reverb1DryGainNode.connect(this.masterGain);
    this.audioTrack.connect(this.reverb1ConvFilter);
    this.reverb1ConvFilter.connect(this.reverb1LowpassFilter);
    this.reverb1LowpassFilter.connect(this.reverb1HighpassFilter);
    this.reverb1HighpassFilter.connect(this.reverb1WetGainNode);
    this.reverb1WetGainNode.connect(this.masterGain);
    this.setState({ reverb1Connected: true });
  }
  reverb1Disconnect() {
    this.audioTrack.disconnect(this.reverb1DryGainNode);
    this.reverb1DryGainNode.disconnect(this.masterGain);
    this.audioTrack.disconnect(this.reverb1ConvFilter);
    this.reverb1ConvFilter.disconnect(this.reverb1LowpassFilter);
    this.reverb1LowpassFilter.disconnect(this.reverb1HighpassFilter);
    this.reverb1HighpassFilter.disconnect(this.reverb1WetGainNode);
    this.reverb1WetGainNode.disconnect(this.masterGain);
    this.setState({ reverb1Connected: false });
  }

  reverb2Connect() {
    this.audioTrack.connect(this.reverb2DryGainNode);
    this.reverb2DryGainNode.connect(this.masterGain);
    this.audioTrack.connect(this.reverb2ConvFilter);
    this.reverb2ConvFilter.connect(this.reverb2LowpassFilter);
    this.reverb2LowpassFilter.connect(this.reverb2HighpassFilter);
    this.reverb2HighpassFilter.connect(this.reverb2WetGainNode);
    this.reverb2WetGainNode.connect(this.masterGain);
    this.setState({ reverb2Connected: true });
  }

  reverb2Disconnect() {
    this.audioTrack.disconnect(this.reverb2DryGainNode);
    this.reverb2DryGainNode.disconnect(this.masterGain);
    this.audioTrack.disconnect(this.reverb2ConvFilter);
    this.reverb2ConvFilter.disconnect(this.reverb2LowpassFilter);
    this.reverb2LowpassFilter.disconnect(this.reverb2HighpassFilter);
    this.reverb2HighpassFilter.disconnect(this.reverb2WetGainNode);
    this.reverb2WetGainNode.disconnect(this.masterGain);
    this.setState({ reverb2Connected: false });
  }

  handelMute() {
    if (this.state.solo) this.handelSolo();
    this.audioElement.volume = this.state.muted ? this.state.volume : 0;
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "state",
      this.state.muted ? "normal" : "muted"
    );
    this.setState((prevState) => ({ muted: !prevState.muted }));
  }

  handelSolo(preventSideEffects) {
    if (this.state.solo) {
      return this.setState((prevState) => ({ solo: !prevState.solo }));
    }
    if (this.state.muted) this.handelMute();
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "state",
      this.state.solo ? "normal" : "solo"
    );
    this.setState((prevState) => ({ solo: !prevState.solo }));
    if (!preventSideEffects)
      this.props.soloSideEffectFunction(this.props.layerId);
  }

  handelReverb1(newValue) {
    if (newValue === 0 && this.state.reverb1Connected) {
      this.reverb1Disconnect();
    }
    if (newValue > 0 && !this.state.reverb1Connected) {
      this.reverb1Connect();
    }
    this.reverb1WetGainNode.gain.setValueAtTime(
      newValue / 100,
      this.audioContext.currentTime
    );
    this.reverb1DryGainNode.gain.setValueAtTime(
      1 - newValue / 100,
      this.audioContext.currentTime
    );
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "reverb1",
      newValue / 100
    );
    this.setState({ reverb1Value: newValue / 100 });
  }
  handelReverb2(newValue) {
    if (newValue === 0 && this.state.reverb2Connected) {
      this.reverb2Disconnect();
    }
    if (newValue > 0 && !this.state.reverb2Connected) {
      this.reverb2Connect();
    }
    this.reverb2WetGainNode.gain.setValueAtTime(
      newValue / 100,
      this.audioContext.currentTime
    );
    this.reverb2DryGainNode.gain.setValueAtTime(
      1 - newValue / 100,
      this.audioContext.currentTime
    );
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "reverb2",
      newValue / 100
    );
    this.setState({ reverb2Value: newValue / 100 });
  }

  handelEQ1ValueChange(value) {
    if (value <= 0 && this.state.eq1Connected) {
      this.eq1Disconnect();
    }
    if (value > 0 && !this.state.eq1Connected) {
      this.eq1Connect();
    }

    if (value > 4 || value < 0) return;
    this.eq1GainNode.gain.setValueAtTime(
      value * 0.25,
      this.audioContext.currentTime
    );
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "eq1",
      value
    );
    this.setState({ eqFilter1Value: value });
  }

  handelEQ2ValueChange(value) {
    if (value > 4 || value < -4) return;
    value = Math.abs(value);
    if (value === 0 && this.state.eq2Connected) {
      this.eq2Disconnect();
    }
    if (value !== 0 && !this.state.eq2Connected) {
      this.eq2Connect();
    }
    this.eq2GainNode.gain.setValueAtTime(
      value * 0.25,
      this.audioContext.currentTime
    );
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "eq2",
      value
    );
    this.setState({ eqFilter2Value: value });
  }

  getStateName() {
    if (this.state.muted) return "red";
    if (this.state.solo) return "green";
    if (this.props.isDecorative) return "off";
    return "yellow";
  }

  handelVolumeChange(newVolume) {
    this.audioElement.volume = this.state.muted ? 0 : newVolume;
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "volume",
      newVolume
    );
    this.setState({ volume: newVolume });
  }
  handelPanningChange(newPan) {
    this.pannerNodeInstance.pan.value = newPan;
    this.props.preferenceChangeHandler(
      Math.max(1, this.props.currentTrackNumber),
      this.props.layerId,
      "panning",
      newPan
    );
    this.setState({ panning: newPan });
  }

  play() {
    this.audioContext.resume();
    this.audioElement.play();
  }
  pause() {
    this.audioElement.pause();
  }
  stop() {
    this.props.stateChanger(this.props.name, "readyToPlay");
  }
  toggleMute() {
    this.handelMute();
  }
  setMute(muteState) {
    if (muteState !== this.state.muted) this.handelMute();
  }
  setSolo(soloState, preventSideEffects) {
    if (soloState !== this.state.solo) this.handelSolo(preventSideEffects);
  }
  changePlaybackSpeed(newSpeed) {
    if (!this.audioElement) return;
    this.audioElement.playbackRate = newSpeed;
  }
  changeCurrentTime(newPortion) {
    this.audioElement.currentTime = newPortion * this.audioElement.duration;
  }
  setNewCurrentTime(currentTime) {
    this.audioElement.currentTime = currentTime;
  }
  deselect() {
    this.setState({ selectedState: false });
  }
  resetEffects = () => {
    this.handelReverb1(0);
    this.handelReverb2(0);
    this.handelEQ1ValueChange(0);
    this.handelEQ2ValueChange(0);
    this.eq1ButtonRef.current.reset();
    this.eq2ButtonRef.current.reset();
    this.eq3ButtonRef.current.reset();
    this.eq4ButtonRef.current.reset();
    this.eq5ButtonRef.current.reset();
    this.phoneButtonRef.current.reset();
    this.handelVolumeChange(1);
    this.handelPanningChange(0);
  };

  getPreferences = () => {
    return {
      reverb1: this.state.reverb1Value,
      reverb2: this.state.reverb2Value,
      eq1: this.state.eqFilter1Value,
      eq2: this.state.eqFilter2Value,
      eq3: this.state.eqFilter3Value,
      flanger: this.state.flangerValue,
      robot: this.state.robot,
      phone: this.state.phone,
      volume: this.state.volume,
      panning: this.state.panning,
      state: this.state.muted ? "muted" : this.state.solo ? "solo" : "normal",
    };
  };

  initiateComponents = () => {
    this.audioElement = document.querySelector(`#${this.props.name}`);

    this.audioTrack = this.audioContext.createMediaElementSource(
      this.audioElement
    );

    this.audioElement.addEventListener("timeupdate", () => {
      if (
        isNaN(this.audioElement.duration) ||
        isNaN(this.audioElement.currentTime)
      )
        return 0;
      if (this.props.announcCurrenttime) {
        this.props.announcCurrenttime(this.audioElement.currentTime);
      }
      let index = this.timestamps.filter(
        (element) => element < this.audioElement.currentTime
      ).length;
      let trackStartTime = this.timestamps[index - 1];
      let trackEndTime = this.timestamps[index];

      this.props.announceCurrentPortion(
        (this.audioElement.currentTime - trackStartTime) /
          (trackEndTime - trackStartTime)
      );
    });

    this.audioElement.addEventListener("waiting", () => {
      this.props.stateChanger(this.props.name, "waiting");
    });
    this.audioElement.addEventListener("canplaythrough", () => {
      this.props.stateChanger(this.props.name, "readyToPlay");
    });

    this.audioElement.addEventListener("ended", () => {
      this.props.stateChanger(this.props.name, "ended");
    });

    this.audioTrack.connect(
      this.props.mergerNodeReference,
      0,
      this.props.layerNumber
    );

    this.audioTrack.connect(this.masterGain);
    this.masterGain.connect(this.pannerNodeInstance);
    this.pannerNodeInstance.connect(this.props.audioDestination);
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.isDecorative !== this.props.isDecorative &&
      !this.props.isDecorative
    ) {
      this.initiateComponents();
    }
    if (
      prevProps.initialReverb1 !== this.props.initialReverb1 &&
      this.props.initialReverb1 !== this.state.reverb1Value
    ) {
      this.handelReverb1(this.props.initialReverb1);
    }
    if (
      prevProps.initialReverb2 !== this.props.initialReverb2 &&
      this.props.initialReverb2 !== this.state.reverb2Value
    ) {
      this.handelReverb2(this.props.initialReverb2);
    }
    if (
      prevProps.initialEQ1 !== this.props.initialEQ1 &&
      this.props.initialEQ1 !== this.state.eqFilter1Value
    ) {
      this.handelEQ1ValueChange(this.props.initialEQ1);
    }
    if (
      prevProps.initialEQ2 !== this.props.initialEQ2 &&
      this.props.initialEQ2 !== this.state.eqFilter2Value
    ) {
      this.handelEQ2ValueChange(this.props.initialEQ2);
    }
    if (
      prevProps.initialVolume !== this.props.initialVolume &&
      this.props.initialVolume !== this.state.volume
    ) {
      this.handelVolumeChange(this.props.initialVolume);
    }
    if (
      prevProps.initialPanning !== this.props.initialPanning &&
      this.props.initialPanning !== this.state.panning
    ) {
      this.handelPanningChange(this.props.initialPanning);
    }
    if (
      prevProps.initialMuted !== this.props.initialMuted &&
      this.props.initialMuted !== this.state.muted
    ) {
      this?.setMute(this.props.initialMuted);
    }
    if (
      prevProps.initialSolo !== this.props.initialSolo &&
      this.props.initialSolo !== this.state.initialSolo
    ) {
      this?.setSolo(this.props.initialSolo, true);
    }
  }

  componentDidMount() {
    if (this.props.isDecorative) return;

    this.initiateComponents();
  }

  render() {
    return (
      <Grid
        container
        direction="column"
        style={{
          height: "100%",
          gridColumnStart: "1",
          gridRowStart: "1",
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Grid item direction="row" style={{ height: "74%", width: "100%" }}>
          <div
            onClick={(e) => {
              this.setState({ selectedState: true });
              this.props.handelSelectionFunction(this.props.name);
            }}
            style={{
              width: "19.5%",
              height: "100%",
              backgroundColor: this.state.selectedState ? "#ffff0022" : "",
              position: "relative",
              left: this.props.layerPosition * 19.5 + 1 + "%",
            }}
          >
            {this.props.isDecorative && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 12,
                }}
              ></div>
            )}
            <Grid
              item
              container
              direction="column"
              style={{
                height: "100%",
                width: "100%",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              {!this.props.isDecorative && (
                <audio
                  crossOrigin="anonymous"
                  id={this.props.name}
                  src={this.props.src}
                ></audio>
              )}
              <Grid container item style={{ width: "100%", height: "12.28%" }}>
                <Grid
                  item
                  xs={12}
                  style={{ ...styles.knobGrid }}
                  onClick={() => this.handelMute(this.props.name)}
                  onDoubleClick={() => this.handelSolo()}
                >
                  <img
                    src={getNamesAsset(this.props.name, this.getStateName())}
                    style={styles.muteControlButton}
                  />
                </Grid>
              </Grid>
              <Grid item style={{ width: "100%", height: "19.43%" }}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "75%",
                    height: "75%",
                    left: "12.5%",
                    position: "relative",
                  }}
                  skin={pannerKnob}
                  min={-100}
                  max={100}
                  value={this.state.panning * 100 || 0}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(value - this.state.panning * 100);
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelPanningChange(value / 100.0);
                    }
                  }}
                />
              </Grid>

              <Grid container item style={styles.slider}>
                <div style={styles.sliderBase}>
                  <Slider
                    sx={{
                      ...{
                        "@media (pointer: coarse)":{
                          padding: "0 47%",
                        },
                        [this.props.portrait ? "left" : "padding"]: this.props
                          .portrait
                          ? this.props.percentOfWidth(2)
                          : `0 47%`,
                      },
                      '& input[type="range"]': {
                        WebkitAppearance: "slider-vertical",
                      },
                      "& .MuiSlider-track": {
                        backgroundColor: this.props.isDecorative
                          ? "#333333"
                          : "#00ff00cc",
                        border: this.props.isDecorative
                          ? "none"
                          : "1px solid #00ff00cc",
                      },
                      "& .MuiSlider-thumb": {
                        backgroundImage: `url(${sliderSlide})`,
                        backgroundSize: "100% auto",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundColor: "#00000000",
                        stroke: 0,
                        boxShadow: "none",
                        width: "60%",
                        left: "50.5%",
                        borderRadius: 0,
                        "::before": {
                          boxShadow: "none",
                        },
                      },
                    }}
                    orientation="vertical"
                    min={0}
                    max={100}
                    aria-label="Temperature"
                    valueLabelDisplay="auto"
                    value={this.state.volume * 100}
                    onChange={(e) => {
                      this.handelVolumeChange(e.target.value / 100);
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          item
          container
          direction="row"
          columns={80}
          display={this.state.selectedState ? "display" : "none"}
          style={{
            height: "26%",
            width: "97%",
            left: "1.5%",
            position: "relative",
            zIndex: 5,
          }}
        >
          <Grid item xs={13}>
            <div
              style={{
                ...styles.filterResetBtn,
                backgroundImage: `url(${
                  this.state.pressingResetButton
                    ? filterResetButton_in
                    : filterResetButton_out
                })`,
              }}
              onClick={this.resetEffects}
              onMouseDown={() => this.setState({ pressingResetButton: true })}
              onMouseUp={() => this.setState({ pressingResetButton: false })}
              onMouseLeave={() => this.setState({ pressingResetButton: false })}
            ></div>
          </Grid>
          <Grid item xs={23}>
            <Grid container style={styles.fullContainer}>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "15%",
                    top: "3%",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={0}
                  max={100}
                  value={this.state.reverb2Value * 100 || 0}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(
                      value - this.state.reverb2Value * 100
                    );
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelReverb2(value);
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Knob
                  style={{
                    display: "inline-block",
                    width: "70%",
                    height: "73%",
                    left: "15%",
                    top: "3%",
                    position: "relative",
                  }}
                  skin={filterKnob}
                  min={0}
                  max={100}
                  value={this.state.reverb1Value * 100 || 0}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={310}
                  rotateDegrees={-155}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(
                      value - this.state.reverb1Value * 100
                    );
                    if (distance > maxDistance) {
                      return;
                    } else {
                      this.handelReverb1(value);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={44}>
            <Grid container style={styles.fullContainer}>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  value={this.state.eqFilter1Value}
                  layerName={this.props.name + "-EQ1"}
                  textSize={this.props.percentOfWidth(2.5)}
                  min={0}
                  max={4}
                  ref={this.eq1ButtonRef}
                  onValueChange={(value) => {
                    this.handelEQ1ValueChange(value);
                    this.setState({ eqFilter1Value: value });
                    // setEqFilter1Value(value);
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  value={this.state.eqFilter2Value}
                  layerName={this.props.name + "-EQ2"}
                  min={-4}
                  max={4}
                  textSize={this.props.percentOfWidth(2.5)}
                  ref={this.eq2ButtonRef}
                  onValueChange={(value) => {
                    this.handelEQ2ValueChange(value);
                    this.setState({ eqFilter2Value: value });
                    // setEqFilter2Value(value);
                  }}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  textSize={this.props.percentOfWidth(2.5)}
                  value={0}
                  ref={this.eq3ButtonRef}
                  locked
                  onValueChange={() => {}}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  textSize={this.props.percentOfWidth(2.5)}
                  value={0}
                  ref={this.eq4ButtonRef}
                  locked
                  onValueChange={() => {}}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  textSize={this.props.percentOfWidth(2.5)}
                  value={0}
                  ref={this.phoneButtonRef}
                  locked
                  onValueChange={() => {}}
                />
              </Grid>
              <Grid item xs={2} style={{ padding: "0% 3% 7% 0%" }}>
                <UpDownButton
                  textSize={this.props.percentOfWidth(2.5)}
                  value={0}
                  ref={this.eq5ButtonRef}
                  locked
                  onValueChange={() => {}}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default UniversalControler;
